import { AclAccessLevelEnum, AclMemberRole, AclRole } from '@/services/models/Enums';

export default {
  '*': AclAccessLevelEnum.fullAccess,
  'profile': {
    'general:redirect': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'upload-conversions': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'domains': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'bot-filters': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'subscription': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'referral-program': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'integrations': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.fullAccess,
    },
    'integrations:voluum': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'multi-user-access': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclMemberRole.memberUser]: AclAccessLevelEnum.deny,
    },
    'multi-user-access:workspaces': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'multi-user-access:user-management': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'multi-user-access:shared-reports': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclMemberRole.memberUser]: AclAccessLevelEnum.deny,
    },
    'custom-conversions': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    },
    'plan-description': {
      '*': AclAccessLevelEnum.fullAccess,
      [AclRole.member]: AclAccessLevelEnum.deny,
    }
  },
};